export const pageList = [
  {
    key: 'Accessories',
    value: 'addons.html',
  },
  {
    key: 'InstallType',
    value: 'setup.html',
  },
  {
    key: 'ShoppingCart',
    value: 'cart.html',
  },
  {
    key: 'ExpressCheckOut',
    value: 'expresscheckout.html',
  },
  {
    key: 'PromoHub',
    value: '/nextgen/expresscart.html',
  },
  {
    key: 'CreditPage',
    value: 'creditstatus.html',
  },
  {
    key: 'Appointment',
    value: 'appointment.html',
  },
  {
    key: 'ShippingOptions',
    value: 'shipping.html',
  },
  {
    key: 'Payment',
    value: 'payment.html',
  },
  {
    key: 'Agreements',
    value: 'expresstos.html',
  },
  {
    key: 'ContactInfo',
    value: 'contactinfo.html',
  },
];
